import React from 'react';
import PropTypes from 'prop-types';

export default function GlistActionsCell(props:any) {

    const Component = props.column.component;

    return (
        <div className="cell actions" style={{width: props.column.width}}>
            <Component module={props.module} column={props.column} record={props.data} reRender={props.reRender}/>
        </div>
    );

}

GlistActionsCell.propTypes = {
    module: PropTypes.object,
    column: PropTypes.object,
    data: PropTypes.object,

    reRender: PropTypes.func,
}
